import { AuthData } from "./auth";
import { ClientData } from "./client";
import { Database } from "./database";
import { EmbedData } from "./embed";
import { EventData } from "./event";
import { MessageData } from "./messages";
import { NetworkProvider } from "./network";
import { PaymentProvider } from "./payment";
import { RequestProvider } from "./request";
import { StorageFb } from "./storage";
import { StreamingData } from "./streaming";
import { MenuControl } from "./menu";
import { UtilitiesProvider } from "./utilities";
import { TrackingData } from "./tracking";
import { SponsorProvider } from "./sponsor";
import { CatalogData } from "./catalog";
import { GenFormBuilder } from './form';
import { NotificationData } from "./notification";
import { PollData } from "./poll";
import { CommercialSamplesData } from "./commercial_samples";
import { GamificationProvider } from "./gamification";
import { StripeProvider } from "./stripe";
import { VotingData } from './voting';
import { StaffData } from "./staff";
import { AnalyticsData } from "./analytics";
import { CommentData } from "./comments";
import { ReserveProvider } from "./reserves";
import { CouponData } from "./coupon";
import { FavoritesData } from "./favorites";
import { HistoryData } from "./history";
import { EmailProvider } from "./email";
import { ZeusData } from "./zeus";
import { TicketData } from "./ticket";
import { ColorCategoriesData } from "./colorCategories";
import { PQRData } from "./pqr";
import { CategoriesStaffData } from "./categories_staff";
import { ServiceProvider } from "./services";

export const PROVIDERS = [
  AuthData,
  ClientData,
  Database,
  EmbedData,
  EventData,
  MessageData,
  NetworkProvider,
  PaymentProvider,
  RequestProvider,
  StorageFb,
  StreamingData,
  MenuControl,
  UtilitiesProvider,
  TrackingData,
  SponsorProvider,
  CatalogData,
  ColorCategoriesData,
  FavoritesData,
  CouponData,
  PQRData,
  CategoriesStaffData,
  GenFormBuilder,
  NotificationData,
  PollData,
  CommercialSamplesData,
  GamificationProvider,
  StripeProvider,
  VotingData,
  StaffData,
  AnalyticsData,
  CommentData,
  ReserveProvider,
  HistoryData,
  EmailProvider,
  ZeusData,
  TicketData,
  ServiceProvider
];



// WEBPACK FOOTER //
// ./src/providers/index.ts